<template>
  <div id="journal" ref="index">
    <!-- kv -->
    <kv v-if="banner.length > 0" :banner="banner"></kv>
    <!-- 捐款方式 -->
    <section class="method" data-aos="fade-up" data-aos-once="true" ref="method">
      <div class="container">
        <h2 class="text-secondary">奇蹟會訊</h2>
        <div v-if="usages.length !== 0"  class="row">
          <div
            v-for="(item, index) in usages"
            :key="index"
            class="col-lg-4 col-sm-6"
            data-aos="flip-up"
            data-aos-once="true"
            :data-aos-delay="index*100"
          >
            <div
              @click.prevent="showPdf(item.pdf.data[0].path)"
              class="method-box d-flex flex-column align-items-center"
            >
              <div class="method-img d-flex align-items-center justify-content-center">
                <img
                  v-if="item.cover.data.length>0"
                  v-lazy="item.cover.data[0].medium"
                  :key="item.id"
                />
              </div>
              <!-- <h5 class="method-title">{{item.name}}</h5> -->
                <h5 class="content-title border-type-dash text-primary pb-10 m-0 w-100 pt-10">{{ item.name }}</h5>
                <p class="py-10 d-flex justify-content-between align-items-center w-100" v-if="item.issue">
                  <span class="d-flex align-items-center ">
                    <i class="material-icons text-primary">stop</i>
                    {{item.issue}}
                  </span>
                  <span class="badge"
                  :class="{'badge-other':item.type!='月刊','badge-monthly':item.type==='月刊'}"
                  >{{item.type}}</span>
                </p>
            </div>
          </div>
        </div>
        <div v-else class="h-100">
          <p class="text-center pt-100 no-info ">目前尚無刊物。</p>
        </div>
        <nav v-if="usages.length !== 0" aria-label="Page navigation example">
          <ul class="pagination d-flex align-items-center justify-content-center">
            <li class="page-item" :class="{'disabled':pagination.current_page===1}">
              <a
                class="page-link p-0 h-100 d-flex align-items-center justify-content-center text-primary"
                href="#"
                @click.prevent="searchData.page=1"
              >
                <i class="material-icons">first_page</i>
              </a>
            </li>
            <li class="page-item" :class="{'disabled':pagination.current_page===1}">
                <a
                  class="page-link p-0 h-100 d-flex align-items-center justify-content-center text-primary"
                  href="#"
                  @click.prevent="searchData.page=searchData.page-1"
                >
                  <i class="material-icons">keyboard_arrow_left</i>
                </a>
                </li>
                <li class="page-item" v-for="(item, index) in pageIndex" :key="index">
                  <a
                    class="page-link"
                    :class="{'active': pagination.current_page===item}"
                    href="#"
                    @click.prevent="searchData.page=item"
                  >{{item}}</a>
                </li>
                <li
                  class="page-item"
                  :class="{'disabled':pagination.current_page===pagination.total_pages}"
                >
                  <a
                    class="page-link p-0 h-100 d-flex align-items-center justify-content-center text-primary"
                    href="#"
                    @click.prevent="searchData.page=searchData.page+1"
                  >
                    <i class="material-icons">keyboard_arrow_right</i>
                  </a>
                </li>
                <li
                  class="page-item"
                  :class="{'disabled':pagination.current_page===pagination.total_pages}"
                >
                  <a
                    class="page-link p-0 h-100 d-flex align-items-center justify-content-center text-primary"
                    href="#"
                    @click.prevent="searchData.page=pagination.total_pages"
                  >
                    <i class="material-icons">last_page</i>
                  </a>
            </li>
          </ul>
        </nav>
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import kv from '@/components/kv.vue';

export default {
  name: 'journal',
  metaInfo: {
    title: ' - 奇蹟會訊',
  },
  components: {
    kv,
  },
  data() {
    return {
      banner: [],
      usages: [],
      detail: false,
      searchData: {
        orderBy: 'issue',
        sortedBy: 'desc',
        limit: 12,
        page: 1,
      },
      pagination: {},
    };
  },
  computed: {
    ...mapGetters(['screenWidth']),
    kv_id() {
      return this.screenWidth >= 576 ? 12 : 13;
    },
    pageIndex() {
      const current = this.pagination.current_page;
      const total = this.pagination.total_pages;
      if (total <= 5) {
        const page = [];
        for (let i = 1; i <= total; i += 1) {
          page.push(i);
        }
        return page;
      }
      if (current >= 4) {
        if (current <= total - 2) {
          return [current - 2, current - 1, current, current + 1, current + 2];
        }
        return [total - 4, total - 3, total - 2, total - 1, total];
      }
      const page = [];
      for (let i = 1; i <= 5; i += 1) {
        page.push(i);
      }
      return page;
    },
  },
  methods: {
    showPdf(url) {
      window.open(url, '_blank');
    },
    getBanner() {
      const url = `/banner/${this.kv_id}`;
      this.axios
        .get(url)
        .then((response) => {
          this.banner = response.data.data.file.data;
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
        });
    },
    getUsage() {
      const url = '/journal';
      const params = this.searchData;
      this.axios
        .get(url, { params })
        .then((response) => {
          this.usages = response.data.data;
          this.pagination = response.data.meta.pagination;
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
        });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    this.getBanner();
    this.getUsage();
    if (this.$route.params.id) {
      const target = this.$route.params.id;
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs[target].scrollIntoView();
        }, 800);
      });
    } else {
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollToTop();
        }, 500);
      });
    }
  },
  watch: {
    detail(val) {
      this.detail = val;
    },
    'searchData.page': function changePage() {
      this.getUsage(this.searchData);
    },
    kv_id() {
      this.getBanner();
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/all.scss';

#journal {
  // width: calc(100vw - 5px);
  // overflow-x: hidden;

  .no-info {
    font-size: 24px;
    color: #a6a6a6;
  }

  .border-type-dash {
    border-bottom: 1px dashed $secondary-white;
  }
  .badge-monthly {
    color: #fff;
    background: $journal-monthly;
  }
  .badge-other {
    color: #fff;
    background: $journal-other;
  }
  section:not(.hooper):not(.kv) {
    min-height: 450px;
    padding: 40px 0;
    a {
      color: #000000;
      text-decoration: none;
    }
    .section-title {
      color: $secondary;
      position: relative;
      z-index: 1;
      &::before {
        position: absolute;
        content: '';
        height: 5px;
        background-color: $primary;
        opacity: 0.3;
        right: 0;
        left: 0;
        top: 12px;
        z-index: -1;
      }
    }
    // 捐款方式
    &.method {
      padding: 50px 0;
      .method-box {
        background-color: white;
        border: 1px solid $secondary-white;
        border-radius: 5px;
        padding: 15px;
        cursor: pointer;
        overflow: hidden;
        margin-top: 30px;
        transition: 0.5s ease-in-out;
        .method-img {
          width: auto;
          height: 450px;
          // padding: 30px;
          // margin-top: 20px;
          // margin: 20px 80px 0;
          // border-radius: 50%;
          img {
            width: auto;
            height: 100%;
          }
        }
        .method-img-2 {
          width: 300px;
          height: auto;
          padding: 0 30px 30px;
          border-radius: 50%;
          img {
            width: 100%;
            height: auto;
          }
        }
        .method-title {
          margin: 20px 0 30px;
          letter-spacing: 5px;
        }
        .method-desc {
          line-height: 1.75em;
          letter-spacing: 1.5px;
        }
      }
    }
    .pagination {
      padding-top: 50px;
      a {
        border: none;
        &:hover,
        &.active {
          color: $sub-primary;
        }
      }
    }
  }
}
</style>
